class CarGallery {
    async init() {
        const { default: SimpleLightbox } = await import(/* webpackChunkName: "simplelightbox" */ 'simplelightbox');
        new SimpleLightbox('.car-detail-gallery__items a');
    }
}
export default new CarGallery();
